import {
  SET_IS_DEFAULT_FEEDBACK_MESSAGES_LOADING,
  SET_DEFAULT_FEEDBACK_MESSAGES,
  DEFAULT_FEEDBACK_MESSAGES_SUCCESS,
  SET_IS_SUBMITTING_FEEDBACK,
  SET_REMOVE_FEEDBACK,
  SET_ADD_UPDATE_FEEDBACK
} from './reducer';

export const setIsDefaultMessagesLoading = isLoading => ({
  type: SET_IS_DEFAULT_FEEDBACK_MESSAGES_LOADING,
  payload: isLoading,
});

export const setDefaultMessages = defaultMessages => ({
  type: SET_DEFAULT_FEEDBACK_MESSAGES,
  payload: defaultMessages,
});

export const setIsDefaultMessagesSuccess = isSuccess => ({
  type: DEFAULT_FEEDBACK_MESSAGES_SUCCESS,
  payload: isSuccess,
});

export const setIsSubmittingFeedback = isLoading => ({
  type: SET_IS_SUBMITTING_FEEDBACK,
  payload: isLoading,
});

export const removeFeedbackForLot = payload => ({
  type: SET_REMOVE_FEEDBACK,
  payload,
});

export const addOrUpdateFeedbackForLot = payload => ({
  type: SET_ADD_UPDATE_FEEDBACK,
  payload,
});